import { Search, X } from "lucide-react";
import React from "react";
import { Input } from "./ui/input";

const SearchInput = ({
  searchParamData,
  handleSearchChange,
  handleClearSearch,
  clearable = true
}) => {
  return (
    <div className="relative w-full max-w-sm">
      {/* Search Icon */}
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <Search className="w-4 h-4 text-gray-500" />
      </div>

      {/* Input Field */}
      <Input
        value={searchParamData ? searchParamData : ""}
        onChange={handleSearchChange}
        placeholder="Search"
        className="pl-9 pr-9 h-8 bg-background" // Padding for the search icon and clear button
      />

      {/* Clear Button */}
      {searchParamData && clearable && (
        <button
          onClick={handleClearSearch}
          className="absolute inset-y-0 right-0 flex items-center pr-3"
        >
          <X className="w-4 h-4 text-gray-500" />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
